import router from '../router.js'
import store from '../store.js'
let market = false

var xhrModule = {
	cachedEntities: null,
	get: function (url, callback, errorCallback) {
		fetch(url)
			.then(response => {
				var statusCode = response.status

				if (statusCode === 403) {
					document.querySelector('body').classList.remove('loading')
					router.push({ path: '/dashboard' }, onComplete => {}, onAbort => { })
					return Promise.reject('Forbidden')
				}

				if (statusCode === 504) {
					return Promise.reject('timeout')
				}

				if (statusCode === 200) {
					return response.json()
				}
			})
			.then(data => {
				if (url === '/cms/api/entities') {
					// cache response when fetching /entities for future use
					this.cachedEntities = data.data
				}

				// add url to data
				data['url'] = url

				// send callback
				callback(data)
				this.checkIfStillLoggedIn(data)

				// if we asked for the markets we can update the freshdesk plugin with the correct market
				if (!market && url === '/cms/api/markets') {
					market = true
					var locale = data.data[Object.keys(data.data)[0]].locale.slice(-2)
					if (window.FreshworksWidget) {
						window.FreshworksWidget('prefill', 'ticketForm', {
							custom_fields: {
								cf_market: locale
							}
						})
					}
				}
			})
			.catch(error => {
				console.error('error: ', error)
				if (errorCallback) errorCallback(error)
			})
	},

	download: function (url, callback) {
		fetch(url)
			.then(async response => {
				var statusCode = response.status

				if (statusCode === 403) {
					document.querySelector('body').classList.remove('loading')
					router.push({ path: '/dashboard' }, onComplete => {}, onAbort => { })
					return Promise.reject('Forbidden')
				}

				if (statusCode === 200) {
					return {
						filename: response.headers.get('content-disposition'),
						blob: await response.blob()
					}
				}
			})
			.then(data => {
				callback(data)
			})
			.catch(error => {
				console.error('error: ', error)
			})
	},

	post: function (url, json, callback, failedCallback) {
		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: json
		})
			.then(response => {
				const statusCode = response.status
				if (statusCode === 401) {
					// user is logged out
					document.querySelector('body').classList.remove('loading')
					router.push({ path: '/dashboard' }, onComplete => {}, onAbort => { })
					return Promise.reject('Forbidden')
				} else if (statusCode !== 200 && statusCode !== 401) {
					if (failedCallback) failedCallback()
					return Promise.reject('error')
				} else {
					return response.json()
				}
			})
			.then(data => {
				callback(data)
				this.checkIfStillLoggedIn(data)
			})
			.catch((error) => {
				if (failedCallback) failedCallback(error)
				console.error('Error:', error)
			})
	},

	checkIfStillLoggedIn: function (data) {
		// check if the user has been logged out by the server
		if (!data) return
		if (data.meta.session.user.username === 'unauthenticated') {
			// mark the user as logged out in the front end and send them to the login page
			store.dispatch('setLoggedOut').then(() => {
				var reload = false
				if (router.currentRoute.name !== null && router.currentRoute.name !== 'login') reload = true

				// reload page to force download new cms version if needed
				if (reload) window.location.reload()
			}).catch(err => {
				console.error(err)
			})
		}
	}
}

export default xhrModule
